import type { AppRoute } from '@ts-rest/core';
import { generateOpenApi } from '@ts-rest/open-api';
import type { OperationObject } from 'openapi3-ts';
import { plannerContract } from './planner.contract.js';
import { unscheduledJobsContract } from './unscheduledJobs.contract.js';

const baseInfo = {
  info: {
    title: 'Skewb Works Planner API',
    version: '1.0.0',
    description:
      'Type-safe planner API for Skewb Works Lite. Covers resource scheduling, event management, and unscheduled job queues.',
    contact: {
      name: 'Skewb Works Development Team',
    },
  },
  servers: [
    { url: 'https://localhost:8080', description: 'Local development server' },
    { url: 'https://api.works-works-lite.dev.skewbdigital.co.uk', description: 'Dev API server' },
  ],
  tags: [{ name: 'Planner', description: 'Scheduling, events, and job queue endpoints' }],
};

const operationMapper = {
  setOperationId: true,
  operationMapper: (operation: OperationObject, _appRoute: AppRoute): OperationObject => ({
    ...operation,
    tags: ['Planner'],
  }),
} as const;

const plannerSpec = generateOpenApi(plannerContract, baseInfo, operationMapper);
const unscheduledJobsSpec = generateOpenApi(unscheduledJobsContract, baseInfo, operationMapper);

export const plannerOpenApiSpec = {
  openapi: plannerSpec.openapi,
  paths: {
    ...plannerSpec.paths,
    ...unscheduledJobsSpec.paths,
  },
  components: {
    schemas: {
      ...plannerSpec.components?.schemas,
      ...unscheduledJobsSpec.components?.schemas,
    },
  },
  tags: baseInfo.tags,
};
